import { render, staticRenderFns } from "./WatchStatisticsBars.vue?vue&type=template&id=68968744&"
import script from "./WatchStatisticsBars.vue?vue&type=script&lang=js&"
export * from "./WatchStatisticsBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports